<template>
  <div class="[ flex flex-col gap-2 items-center ]">
    <ProgressSpinner stroke-width="4" />
    <span class="[ text-sm ]" v-if="props.message">{{ props.message }}</span>
  </div>
</template>

<script setup lang="ts">
import { ProgressSpinner } from "primevue";
interface IProps {
  message?: string | undefined;
}

const props = withDefaults(defineProps<IProps>(), { message: undefined });
</script>
